module.exports = __webpack_public_path__ + "static/media/add-icon.5efa3ea8.svg";